<template>
  <IQOS
    :title="
      is_chain
        ? $t('settings_cafe.online_menu.chain_title')
        : $t('settings_cafe.online_menu.title')
    "
    :enabled="editing"
    required
  >
    <BaseTabSwitcher
      v-model="link_source"
      class="mt-16 w-100"
      fullWidth
      :tabs="[
        {
          text: 'qrwaiter.com.ua',
          value: 'qrwaiter',
        },
        {
          text: $t('settings_cafe.online_menu.tab_domain'),
          value: 'domain',
        },
      ]"
    />

    <div
      class="w-100"
      v-if="link_source == 'qrwaiter'"
    >
      <BaseInput
        fullWidth
        v-model="onlineMenuLink"
        ref="staticMenuLinkInput"
        v-show="false"
        v-if="!editing"
      />

      <div
        class="static-link-container qrw-input-text"
        v-if="!editing"
      >
        <span class="v1-grey-7-color qrw-input-text">cafe.qrwaiter.com.ua/</span>{{ edit_link }}
      </div>

      <div
        class="gap-column-zero mt-16"
        v-if="editing"
      >
        <BaseInput
          class="static-domain"
          :disabled="true"
          :value="'https://cafe.qrwaiter.com.ua/'"
        />

        <BaseInput
          fullWidth
          :disabled="false"
          v-model="edit_link"
          ref="menuLinkInput"
          :valid="!invalid"
        />
      </div>

      <div class="w-100 mt-16 gap-row-1xs">
        <BaseButton
          class="w-100"
          icon="link"
          iconPosition="left"
          color="v1-grey-10"
          size="md"
          align="center"
          variant="secondary"
          @click="copyLink"
          v-if="!editing"
        >
          {{ $t("settings_cafe.online_menu.copy_btn") }}
        </BaseButton>

        <div class="iqos-tooltip-helper-box w-100">
          <IQOSTooltip
            @close="show_link_qrcode = !show_link_qrcode"
            :title="cafe.name"
            :qrLink="onlineMenuLink"
            v-if="show_link_qrcode"
            size="sm"
            earPosition="top-center"
          >
          </IQOSTooltip>
          <BaseButton
            @click="show_link_qrcode = !show_link_qrcode"
            size="md"
            variant="secondary"
            icon="qr-code"
            class="w-100"
          >
            {{ $t("orders_panel_download.btn_qr") }}
          </BaseButton>

        </div>
      </div>

      <p
        class="qrw-paragraph-md iqos-comment mt-16"
        v-if="editing"
      >
        {{ $t("settings_cafe.online_menu.input_link") }}
      </p>
      <p
        class="qrw-paragraph-md iqos-comment mt-8"
        v-if="editing"
      >
        {{ $t("settings_cafe.online_menu.input_hint") }}
      </p>
    </div>

    <div
      class="w-100 mt-16 gap-row-xs"
      v-else
    >
      <BaseInput
        fullWidth
        v-model="custom_domain"
        :valid="!invalid_custom_domain"
        placeholder="yourdomain.com"
        :disabled="!editing"
        v-if="!cafe.custom_domain"
      />

      <BaseInput
        fullWidth
        v-model="cafe.custom_domain"
        placeholder="yourdomain.com"
        :disabled="true"
        iconPosition="right"
        rightIcon="check"
        rightIconColor="green-5"
        v-if="cafe.custom_domain"
      />

      <BaseButton
        variant="secondary"
        size="md"
        @click="connectCustomDomain"
        v-if="!cafe.custom_domain && editing"
      >
        {{ $t('settings_cafe.online_menu.connect_domain') }}
      </BaseButton>

      <div
        class="qrw-paragraph-md iqos-comment"
        v-html="$t('settings_cafe.online_menu.domain_ip_text')"
      >

      </div>

      <div class="qrw-paragraph-md iqos-comment">
        {{ $t('settings_cafe.online_menu.domain_connect_text') }}
      </div>
    </div>

    <template #actions>
      <IQOSActions
        :editing="editing"
        canCancel
        @edit="showEditUI"
        @accept="onEditFinish"
        @cancel="hideEditUI"
      />
    </template>
  </IQOS>
</template>

<style scoped>
.static-link-container {
  width: 100%;
  border-radius: 4px;
  padding: 8px;
  background: var(--v1-grey-4-color);
  box-sizing: border-box;
  margin-top: 16px;
  color: var(--v1-grey-9-color);
}

.static-domain {
  width: 270px;
}
</style>

<script>
import ClipboardService from '@/services/clipboard'

import CafeAPI from '@/api/cafe'

const MENU_LINK_PREFIX = `https://cafe.qrwaiter.com.ua/`

export default {
  data() {
    return {
      editing: false,
      edit_link: null,
      invalid: false,
      link_source: 'qrwaiter',
      custom_domain: null,
      invalid_custom_domain: null,
      show_link_qrcode: false
    }
  },
  watch: {
    custom_domain() {
      this.invalid_custom_domain = false
    }
  },
  props: {
    mode: {
      type: String,
      default: 'delivery'
    },
    is_chain: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showEditUI() {
      this.editing = true
      this.invalid = false

      if (this.isPresent) {
        this.edit_link = this.rawLink
      }
    },
    hideEditUI() {
      this.editing = false
      this.edit_link = this.rawLink
    },
    onEditFinish() {
      if (!this.edit_link || !/^[(a-z)(0-9)_]*$/.test(this.edit_link)) {
        this.invalid = true
        return
      }

      if (!this.edit_link) return

      CafeAPI.checkOnlineMenuLink(this.edit_link)
        .then(data => {
          if (this.is_chain) {
            if (data.entity_id && data.entity_id != this.chain._id) {
              this.invalid = true
              return
            }

            this.$store.commit('setChainData', {
              key: 'link',
              value: this.edit_link
            })
            this.$store.dispatch('saveChain')
          } else {
            if (data.entity_id && data.entity_id != this.cafe._id) {
              this.invalid = true
              return
            }
            this.$store.commit('setCafeOnlineMenuLinkModified', true)
            this.$store.commit('setCafeOnlineMenuLink', this.edit_link)
            this.$store.dispatch('saveCafe')

            this.$store.dispatch('auditlog/write', {
              type: 'online_menu_link',
              payload: {
                link: this.edit_link
              }
            })
          }

          this.editing = false
        })
        .catch(error => {
          this.invalid = true
        })
    },
    onMenuLinkChanged(ev) {
      const value = ev.target.value

      this.invalid = false

      if (value.length < MENU_LINK_PREFIX.length) {
        ev.preventDefault()
        this.$refs.menuLinkInput.getInputElement().value = MENU_LINK_PREFIX
        this.edit_link = ''
        return
      }

      this.edit_link = value.split('/').pop()
    },
    copyLink(event) {
      try {
        const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard

        clipboardData.writeText(this.onlineMenuLink)

        this.$refs.staticMenuLinkInput.getInputElement().select()
        document.execCommand('copy')
      } catch (err) {
        console.error(err)
      }

      ClipboardService.copyToClipboard(this.onlineMenuLink)

      this.$store.commit('ui/addToast', {
        variant: 'confirm',
        content: this.$t('notification_toast.confirm.copied')
      })
    },
    connectCustomDomain() {
      CafeAPI.connectCustomDomain(this.cafe._id, this.custom_domain)
        .then(data => {
          this.$store.commit('patchCafeGeneralData', {
            custom_domain: this.custom_domain
          })
        })
        .catch(err => {
          this.invalid_custom_domain = true
        })
    }
  },
  mounted() {
    if (this.isPresent) {
      this.edit_link = this.rawLink
    }

    if (this.cafe.custom_domain) {
      this.link_source = 'domain'
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe
    },
    chain() {
      return this.$store.state.selected_chain
    },
    isPresent() {
      return !!this.rawLink
    },
    rawLink() {
      return this.is_chain ? this.chain.link : this.cafe.online_menu_link
    },
    onlineMenuLink() {
      return this.$store.getters.onlineMenuLink(this.mode, this.rawLink)
    },
    editLinkMask: {
      get() {
        return `${MENU_LINK_PREFIX}${this.edit_link}`
      },
      set(v) {
        if (v.length < MENU_LINK_PREFIX.length) {
          this.edit_link = ''
          return
        }

        this.edit_link = v.split('/').pop()
      }
    }
  }
}
</script>
